import React from 'react';
import { Col, Row } from 'components/Grid/Grid';
import { Icon, TIconNames } from 'components/Icon';
import { Text } from 'components/Typography';

export const UploadButton = () => {
  return (
    <Row align="middle">
      <Col span={24}>
        <Icon icon={TIconNames.PLUS} size={24} />
      </Col>
      <Col span={24}>
        <Text fontlevel={6}>Upload</Text>
      </Col>
    </Row>
  );
};

export default UploadButton;
